export default __webpack_public_path__ + "static/media/KAVIAR_3.403ab2a0.gif";